import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import {
  BUTTON_CONNECT_ACCOUNT,
  BUTTON_CONNECT_META,
} from "../../i18n/keysTranslations";
import {
  BUTTON_META_ACTION_ID,
  META,
  MODE_BACK_DROP_CONNECT,
} from "../../utils/constants";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp, useSelectorApp } from "../../lib/redux";
import { startConnectFacebook } from "../../actions/user";
import { startAfterPlatformConnected } from "../../actions/agencyAccountLinking";
import { showPlatformConnectedAlert } from "../../utils/showPlatformConnectedAlert";
import { logoPlatform } from "../../utils/string";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "./IconButton";
import Loader from "../Loaders/Loader";
import { ConfirmAlert } from "../Alerts/Alerts";
import BackDropLoader from "../Loaders/BackDropLoader";
import ConnectionProgressModal from "../Containers/ConnectionProgressModal";
import { createPortal } from "react-dom";
import Button from "./Button";

const ButtonMetaAction = ({
  id = BUTTON_META_ACTION_ID,
  text = BUTTON_CONNECT_META,
  disabled = false,
  prevBlockClick = false,
  onPrevBlockClick = () => {},
  onClick = () => {},
  onCallbackOpenPopup = () => {},
  onCallbackCancel = () => {},
  showGlobalLoading = false,
  sx = {},
  // scope = META_SCOPES,
  logo = META,
  showLogo = true,
  hasShadow = true,
  type = "button",
  mode = "verify",
  icon = <AddIcon />,
  disableRipple = false,
  showButtonIcon = false,
  doTranslation = true,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const integrations = useSelectorApp((state) => state?.user?.integrations);
  const metaIntegrations = integrations?.facebook || {};
  const isMetaConnected = Object.values(metaIntegrations).some(
    (integration) => integration.isActive
  );

  const onConnectAccount = async () => {
    const result = await ConfirmAlert({
      icon: false,
      confirmButtonText: t(BUTTON_CONNECT_ACCOUNT),
      html: <ConnectionProgressModal platform={META} />,
      width: "60vh",
    });

    if (!result.isConfirmed) {
      onCallbackCancel();
      return;
    }

    dispatch(
      startConnectFacebook({
        showGlobalLoading,
        onChangeLoadingAuth: (loading) => {
          setIsLoading(loading);
          if (!loading) {
            onCallbackOpenPopup();
          }
        },
        onChangeLoadingConnect: (loading) => setOpenBackDrop(loading),
        onCallbackConnected: async (integration) => {
          await showPlatformConnectedAlert({ t });
          await dispatch(
            startAfterPlatformConnected({ platform: META, integration })
          );
          onClick();
        },
      })
    );
  };

  if (type === "icon") {
    return (
      <>
        {openBackDrop &&
          createPortal(
            <BackDropLoader
              open={openBackDrop}
              platform={META}
              from={MODE_BACK_DROP_CONNECT.GET_INFORMATION}
            />,
            document.body
          )}
        <IconButton
          id={id}
          disableRipple={disableRipple}
          sx={{ ...sx }}
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (prevBlockClick) {
              onPrevBlockClick();
              return;
            }

            if ((!isMetaConnected && mode === "verify") || mode === "add") {
              await onConnectAccount();
              return;
            }

            setIsLoading(true);
            onClick();
            setIsLoading(false);
          }}
        >
          {isLoading ? <Loader hasMarginTop={false} size={20} /> : icon}
        </IconButton>
      </>
    );
  }

  return (
    <>
      {openBackDrop &&
        createPortal(
          <BackDropLoader
            open={openBackDrop}
            platform={META}
            from={MODE_BACK_DROP_CONNECT.GET_INFORMATION}
          />,
          document.body
        )}
      <Button
        id={id}
        loading={isLoading}
        disabled={disabled}
        color="secondary"
        hasShadow={hasShadow}
        sx={{
          width: "100%",
          ...sx,
        }}
        onClick={async (e) => {
          e.preventDefault();
          if (prevBlockClick) {
            onPrevBlockClick();
            return;
          }

          if ((!isMetaConnected && mode === "verify") || mode === "add") {
            await onConnectAccount();
            return;
          }

          setIsLoading(true);
          await onClick();
          setIsLoading(false);
        }}
      >
        {showButtonIcon && icon}
        {showLogo && (
          <Avatar
            src={logoPlatform(logo)}
            variant="square"
            sx={{
              width: "20px",
              height: "20px",
              mr: 1,
              ".MuiAvatar-img": {
                objectFit: "contain",
              },
            }}
          />
        )}
        {doTranslation ? t(text) : text}
      </Button>
    </>
  );
};

export default ButtonMetaAction;
